import {DatePipe}                           from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {BodyRecordLogIntf}                  from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-body',
			   imports    : [
				   DatePipe
			   ],
			   templateUrl: './table-row-body.component.html',
			   styleUrl   : './table-row-body.component.css'
		   })
export class TableRowBodyComponent extends TableRowBase<BodyRecordLogIntf> {
	row = input.required<TableRow<BodyRecordLogIntf>>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
